import { node, icon } from "~/util/dom";
import { _ } from "~/i18n";

export default class PlacesItem {
	_dataItem: any;

	_opts: {
		foreign: boolean;
		setCheckedCounter: () => void;
		draggable: boolean;
		checkbox: boolean;
		showPublic: boolean;
		checked: boolean;
	};

	_output: {
		el: HTMLLIElement;
		title: HTMLHeadingElement;
		desc: HTMLHeadingElement;
		star?: HTMLSpanElement;
		checkbox?: HTMLInputElement;
	};

	constructor(dataItem, opts = {}) {
		this._dataItem = dataItem;
		const _opts = {
			foreign: false,
			setCheckedCounter: () => {},
			draggable: true,
			checkbox: true,
			showPublic: true,
			checked: false,
		};

		this._opts = Object.assign(_opts, opts);
		this._build();
	}

	get data() {
		return this._output;
	}

	set subtitle(desc) {
		this._dataItem.data.desc = desc;
		this._output.desc.textContent = this._dataItem.data.desc;
		this._output.el.title = Mapy.Util.unescapeHTML(`${this._dataItem.data.usertitle ? this._dataItem.data.usertitle : this._dataItem.data.title}\n${this._dataItem.data.desc}`);
	}

	_build() {
		// item listu
		const el = node("li", {
			className: "item",
			title: Mapy.Util.unescapeHTML(`${this._dataItem.data.usertitle ? this._dataItem.data.usertitle : this._dataItem.data.title}\n${this._dataItem.data.desc}`),
		});
		const title = node("h2", { className: "title overflow-ellipsis", textContent: `${this._dataItem.data.usertitle ? this._dataItem.data.usertitle : this._dataItem.data.title}` });
		const desc = node("h3", { className: "desc overflow-ellipsis", textContent: this._dataItem.data.desc });
		const textCover = node("div", { className: "text-cover" });
		const wrapper = node("div");

		this._output = {
			el,
			title,
			desc,
		};

		textCover.appendChild(wrapper);

		el.dataset.id = this._dataItem.data.id;
		// vnitrni cast s obsahem
		const inner = node("div", { className: "inner" });

		el.appendChild(inner);
		// separator, tedy jen cara
		el.appendChild(node("div", { className: "separator" }));
		// handle pro tahani
		if (this._opts.draggable) {
			const points = node("span", { className: "points" });

			points.appendChild(icon("move"));
			inner.appendChild(points);
		}
		// zaskrtavatko pro hromadne akce
		if (this._opts.checkbox) {
			const radio = Mapy.Util.buildRadioCheck("checkbox", `radio${this._dataItem.data.id}`, "");

			radio.input.checked = this._opts.checked;
			radio.input.addEventListener("change", () => {
				this._opts.setCheckedCounter();
			});
			inner.appendChild(radio.label);

			this._output.checkbox = radio.input;
		}

		// fotka
		const imageCover = node("div", { className: "image-cover" });

		if (this._dataItem.imageData.img) {
			imageCover.appendChild(this._dataItem.imageData.img());

			if (this._dataItem.imageData.icon) {
				imageCover.classList.add("icon");
			}
		} else if (this._dataItem.imageData.svg) {
			imageCover.classList.add("svg");
			imageCover.appendChild(this._dataItem.imageData.svg());
		}

		inner.appendChild(imageCover);

		// nazev a popis
		wrapper.appendChild(title);
		wrapper.appendChild(desc);
		inner.appendChild(textCover);

		if (this._opts.foreign) { // cizi oblibene
			const star = node("span", { className: "star" });

			star.appendChild(icon("star-line"));
			inner.appendChild(star);
			this._output.star = star;
		} else if (this._opts.showPublic) { // akce nad mym oblibenym
			const publicEl = node("span", { className: "public-icon" });

			publicEl.appendChild(icon("public"));
			inner.appendChild(publicEl);
			// tlacitko pro menu
			const opts = node("span", { className: "opts" });

			opts.appendChild(icon("etc-vertical"));
			inner.appendChild(opts);

			if (this._dataItem.data.public) {
				el.classList.add("public");
			}
		}

		if (this._dataItem.data.inactive) {
			wrapper.appendChild(node("h3", { className: "inactive", textContent: this._dataItem.data.temporarilyClosed ? _("detail.content.closed.temporarilyClosed") : _("detail.content.closed.title") }));
			textCover.classList.add("with-inactive");
		}

		this._dataItem.parent = el;
	}
}
